/* global axios */
import ApiClient from 'dashboard/api/ApiClient';

class FlowUserFavoritesAPI extends ApiClient {
  constructor() {
    super('flow_user_favorites', { accountScoped: true });
  }

  index() {
    return axios.get(this.url);
  }

  create(flowId) {
    return axios.post(this.url, { flow_id: flowId });
  }

  destroy(flowId) {
    return axios.delete(this.url, { params: { flow_id: flowId } });
  }
}

export default new FlowUserFavoritesAPI();
